import React, { useEffect, useState } from "react"
import C3Chart from "react-c3js"
import "c3/c3.css"
import { useSelector } from "react-redux"
import config from "config/config"
import axios from "axios"

const DonutChart = () => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)
  const [reviews, setReviews] = useState([])
  const [chartData, setChartData] = useState([])

  const fetchReviews = async () => {
    try {
      const integration = activeOrganization?.YelpIntegrations?.[0]
      if (!integration) return

      const response = await axios.get(
        `${config.backendUrl}/yelp/getReviews?integrationId=${integration.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setReviews(response.data.reviews || [])
    } catch (err) {
      console.log("Error fetching Yelp reviews:", err)
    }
  }

  useEffect(() => {
    if (activeOrganization) fetchReviews()
  }, [activeOrganization])

  useEffect(() => {
    if (reviews && reviews.length) {
      const ratingsDistribution = ["1", "2", "3", "4", "5"].map(rating => {
        const count = reviews.filter(
          review => review.rating === rating
        ).length
        return [`${rating} Stars`, count]
      })

      setChartData(ratingsDistribution)
    }
  }, [reviews])

  const data = {
    columns: chartData,
    type: "donut",
  }

  const donut = {
    title: "Ratings Distribution",
    width: 30,
    label: { show: false },
  }

  // ✅ Blue-themed harmonious palette
  const color = {
    pattern: ["#A7D3FF", "#6BB8FF", "#2990DF", "#1E73C9", "#155EAB"],
  }

  const size = {
    height: 300,
  }

  return (
    <React.Fragment>
      <C3Chart data={data} donut={donut} color={color} size={size} dir="ltr" />
    </React.Fragment>
  )
}

export default DonutChart
